import { extraCareServiceName } from '../../constants/services';
import { getFriendlyDate } from '../../date-time';
import { WarrantyPeriod } from '../../types';

export const getWarrantyPeriodString = (
  suggestedWarrantyPeriods: Array<WarrantyPeriod> | undefined
): string | undefined => {
  if (!suggestedWarrantyPeriods?.length) return;

  const warrantyPeriods = suggestedWarrantyPeriods
    .map(warrantyPeriod => {
      if (warrantyPeriod?.name?.includes(extraCareServiceName)) {
        return `From ${getFriendlyDate(warrantyPeriod?.fromDate || '')} to\n${getFriendlyDate(
          warrantyPeriod?.endDate || ''
        )}`;
      }
      return null;
    })
    .filter(Boolean)
    .join('\n');

  return warrantyPeriods || undefined;
};
